"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.POINT = void 0;
var TrackerPoint = /** @class */ (function () {
    function TrackerPoint() {
        this.common = {};
    }
    TrackerPoint.prototype.setPoint = function (point) {
        this.POINT = point;
    };
    TrackerPoint.prototype.setCommonParam = function (key, value) {
        this.common[key] = value;
    };
    TrackerPoint.prototype.click = function (param) {
        this.POINT('h5_clk', __assign(__assign({ page: 'super-成长权益页' }, this.common), param));
    };
    TrackerPoint.prototype.imp = function (param) {
        this.POINT('h5_element_imp', __assign(__assign({ page: 'super-成长权益页' }, this.common), param));
    };
    return TrackerPoint;
}());
exports.POINT = new TrackerPoint();
